/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-vars: 0, no-use-before-define: 0, no-var: 0 */
/* globals _, JSWidget, JSWidgetList, mp */

/*
 * Provides:
 *  mp.widgets.Dropdown
 */



_.namespace(`mp.widgets`, function() {
  "use strict";

  function Dropdown() {
    this.label_class = Label;
    this.body_class = Body;
  }
  _.inherit(Dropdown, JSWidget);

  Dropdown.prototype.create = function(div, items, config) {
    Dropdown.superclass.create.call(this, div);

    this.config = _.extend(this.default_config(), config);

    this.default_label = this.container.html();

    this.label = new this.label_class()
      .create(null, this.config);

    if (this.default_label) {
      this.label.select(this.default_label);
    }

    this.body = new this.body_class()
      .create(null, this.config);

    this.context_panel = $(`<mp-context-panel>`);

    this.container.html(``).append(this.label.container, this.body.container, this.context_panel);

    this.body.fill(items, this.config.separator)
      .label_changed(null, this.label);

    this.bindings();

    if (this.config.select_first && this.body.widgets.length) {
      this.select_item(this.body.widgets[0]);
    }

    if (!_.isUndefined(this.config.selected)) {
      this.select_val(this.config.selected);
    }

    return this;
  };

  Dropdown.prototype.remove = function() {
    mp.utility.unbind_outside_event(`click`, `base_dropdown`);
    Dropdown.superclass.remove.call(this);
  };

  Dropdown.prototype.contains = function(val) {
    return this.body.get_item_by_val(val) !== undefined;
  };

  Dropdown.prototype.deselect_all = function() {
    this.label.select(this.default_label);
    this.body.deselect_all();
  };

  Dropdown.prototype.default_config = function() {
    /*  Config parameters:
         *      select_first:       true if you want the first value to be
         *                          selected
         *      emulate_select:     true if you want the title to change
         *                          when an item is clicked.
         *      menu:               true when you can reselect an
         *                          already selected item.
         *      collapse:           false if you want a min-width, else
         *                          the box will collapse to fit.
         */
    return {
      select_first: false,
      emulate_select: false,
      menu: false,
      collapse: false,
      min_width: 130,
    };
  };

  Dropdown.prototype.enable = function() {
    this.label.enable();
    this.body.enable();
  };

  Dropdown.prototype.disable = function() {
    this.label.disable();
    this.body.disable();
  };

  Dropdown.prototype.toggle_disabled = function(disabled) {
    if (disabled) {
      this.disable();
    } else {
      this.enable();
    }
  };

  Dropdown.prototype.activate = function(ev) {
    this.label.activate(false);
    this.body.activate(false, this.label);
  };

  Dropdown.prototype.deactivate = function(ev) {
    if (ev && ev.target) {
      for (var el = ev.target; el; el = el.parentElement) {
        if (el.matches(`mp-context-panel-internal`)) {
          return;
        }
      }
    }
    this.context_panel.attr(`tooltip-data`, null);
    this.label.deactivate(false);
    this.body.deactivate(false, this.label);
  };

  Dropdown.prototype.selected = function() {
    return this.label.val();
  };

  Dropdown.prototype.val = Dropdown.prototype.selected;

  Dropdown.prototype.select_item = function(item, skip_event) {
    if (!item || (item.selected && !this.config.menu)) { return; }

    if (this.config.emulate_select) {
      this.label.select(item, skip_event);
    }
    this.body.select_item(item, skip_event);
  };

  Dropdown.prototype.disable_val = function(val) {
    var item = this.body.get_item_by_val(val);
    if (item) {
      item.disable();
    }
  };

  Dropdown.prototype.select_val = function(val, skip_event) {
    var item = this.body.get_item_by_val(val);
    if (item) {
      this.select_item(item, skip_event);
      return true;
    } else if (this.config.always_display_content) {
      this.label._set_content([val]);
    }
    return false;
  };

  Dropdown.prototype.select_val_by_id = function(id, skip_event) {
    var item = this.body.get_item_by_id(id);
    if (item) {
      this.select_item(item, skip_event);
      return true;
    }
    return false;
  };

  Dropdown.prototype.bindings = function() {
    this.label.container.bind(`label-activated`, _.bind(this.body.activate, this.body));

    this.label.container.bind(`label-deactivated`, _.bind(this.body.deactivate, this.body));
    this.body.container.bind(`body-deactivated`, _.bind(this.label.deactivate, this.label));

    mp.utility.bind_outside_event(`click`, `base_dropdown`, this.container, this.deactivate, this);

    this.body.container.bind(`dropdown-item-selected`, _.bind(this._item_selected, this));
    this.body.container.bind(`dropdown-item-highlight`, _.bind(this._item_highlight, this));

    this.label.container.bind(`label-changed`, _.bind(this.body.label_changed, this.body));
  };

  Dropdown.prototype.onchange = function(callback) {
    this.container.bind(`item-selected`, function(ev, item, prev) {
      callback(item, prev);
    });
  };

  Dropdown.prototype.update = function(items) {
    var last_val = this.val();
    this.body.fill(items);
    if (last_val !== null) { // maintain item.selected state
      this.select_val(last_val, true);
    }
  };

  Dropdown.prototype.append_item = function(item_widget) {
    this.body.append_item(item_widget);
  };

  Dropdown.prototype.entries = function() {
    return this.body.entries();
  };

  Dropdown.prototype._item_selected = function(ev, item) {
    this.select_item(item);
    this.deactivate(ev);
  };

  Dropdown.prototype._item_highlight = function(ev, item) {
    this.context_panel.attr(`tooltip-data`, JSON.stringify(item.tooltipData));
  };

  /* DropdownLabel is the always visible header of the dropdown */

  function Label() {
    this.disabled = false;
  }
  _.inherit(Label, JSWidget);

  Label.prototype.create = function(div, config) {
    Label.superclass.create.call(this, div);

    this.config = _.extend(this.default_config(), config);

    this.container.addClass(`dropdown_label_widget`);

    if (_.isUndefined(this.title)) {
      this.title = this.container;
    }
    if (!this.config.collapse) {
      this.title.css(`min-width`, this.config.min_width);
    }

    this.deactivate(false);
    this.bindings();

    return this;
  };

  Label.prototype.default_config = function() {
    return {
      // default_config
    };
  };

  Label.prototype.select = function(item, skip_event) {
    this.item = item;
    this.value = typeof(item) === `string` ? item : item.val();
    this._set_content(item);

    if (!skip_event) { this.container.trigger(`label-changed`, this); }

    return this;
  };

  Label.prototype._set_content = function(item) {
    var content = typeof(item) === `string` ? item : item.title();
    if (this.config.raw_html_item_labels) {
      this.title.html(content);
    } else {
      this.title.text(content);
    }
  };

  Label.prototype.enable = function() {
    this.disabled = false;
    this.container.removeClass(`disabled`);
  };

  Label.prototype.disable = function() {
    this.disabled = true;
    this.container.addClass(`disabled`);
  };

  Label.prototype.activate = function(change) {
    if (this.disabled) { return; }
    this.active = true;
    this.container.addClass(`active`);
    if (change) { this.container.trigger(`label-activated`, this); }
  };

  Label.prototype.deactivate = function(change) {
    if (!this.disabled && this.active) {
      this.active = false;
      this.container.removeClass(`active`);
      if (change) { this.container.trigger(`label-deactivated`, this); }
    }
  };

  Label.prototype.toggle_active = function(change) {
    return this.active ? this.deactivate(change) : this.activate(change);
  };

  Label.prototype.bindings = function() {
    this.container.mouseup(_.bind(this.toggle_active, this));
  };

  /* Body is a js widget list of items, and is shown when the dropdown is 'active'
       If this.comparator is defined, it will be used to sort the dropdown list of items */

  function Body() {
    this.item_class = Item;
    this.disabled = false;
    this.comparator = undefined;
    this.prev_item = undefined;
  }
  _.inherit(Body, JSWidgetList);

  Body.prototype.create = function(div, config) {
    Body.superclass.create.call(this, div);

    this.config = _.extend(this.default_config(), config);
    this.progressive_position = this.config.progressive_list_size;

    if (this.config.sortable) {
      this.comparator = function(item) {
        var title = item.title().toLowerCase();
        if (!isNaN(title)) {
          title = parseFloat(title);
        }

        return title;
      };
    }

    this.container.hide();
    this.deactivate(false);
    this.bindings();

    this.container.addClass(`dropdown_body_widget`);

    return this;
  };

  Body.prototype.default_config = function() {
    return {
      sortable: false,
      is_progressive: false,
      progressive_list_size: 50,
      progressive_max_size: 100,
    };
  };

  Body.prototype.bindings = function() {
    this.container.bind(`item-removed`, _.bind(this.remove_item, this));
  };

  Body.prototype.label_changed = function(ev, label) {
    // this is used for modifying the dropdown position in various
    // dropdowns such as the tooltip dropdown
  };

  Body.prototype.fill = function(items, separator) {
    this.clear();

    var init_items = (items) => {

      var tmp_widgets = _.map(items, (item) =>
        item instanceof Item ? item : new this.item_class().create(null, this.config).update(item)
      );

      if (this.config.sortable) {
        tmp_widgets = _.sortBy(tmp_widgets, this.comparator);
      }

      if (this.config.is_progressive) {
        this.$content = this.container.find(`.content`);
        // unregister previous scroll handler if necessary
        if (this._prev_scroll_handler) {
          this.$content.off(`scroll`, this._prev_scroll_handler);
        }

        var filter = this.search && this.search.val();
        if (!filter || !filter.length) { // don't truncate list when filtering; search must include all items
          var scroll_handler = mp.utility.progressive_scroll_handler({
            position: this.progressive_position,
            list_size: this.config.progressive_list_size,
            max_size: this.config.progressive_max_size,
            total_num_items: tmp_widgets.length,
            get_item_height: () => this.$content.children().first().outerHeight(),
            update_position_func: this.update_progressive_position.bind(this),
          });
          this._prev_scroll_handler = scroll_handler;
          // register new scroll handler
          this.$content.scroll(scroll_handler);

          var start = this.config.progressive_max_size;
          var end = this.progressive_position;

          // store full widgets list for later use, then truncate for progressive scrolling
          this.all_widgets = tmp_widgets;
          tmp_widgets = _.last(_.first(tmp_widgets, end), start);
        }
      }

      _.each(tmp_widgets, function(widget) {
        this.append(widget);
        if (widget.bindings) {
          widget.bindings(); // ensure click handler is still assigned
        }
      }, this);

      this.update_items();

    };

    if (separator) {
      items.forEach((item, index, array) => {
        init_items(item);
        if (index < array.length - 1) {
          var dropdown_item = new this.item_class().create(null, this.config).update([undefined, separator]);
          dropdown_item.disable();
          this.append(dropdown_item);
        }
      });
    } else {
      init_items(items);
    }

    return this;
  };

  Body.prototype.update_progressive_position = function(new_position, new_scroll) {
    if (new_scroll) {
      // need to adjust scroll before we change list size, otherwise we may trigger another resize
      this.$content.scrollTo(new_scroll, {duration: 0});
    }
    this.progressive_position = new_position;
    this.fill(this.all_widgets);
  };

  Body.prototype.reset_progressive_scroll = function() {
    if (this.config.is_progressive) {
      this.progressive_scroll_position = this.config.progressive_list_size;
      this.fill(this.all_widgets);
    }
  };

  Body.prototype.append_item = function(item_widget) {
    // Item is not created with item_class, is assumed to already
    // be an item.
    this.append(item_widget);
    this.update_items();
    return this;
  };

  Body.prototype.update_items = function() {
    _.each(this.widgets, function(widget, i) {
      if (i === 0) {
        widget.container.addClass(`first`);
      } else {
        widget.container.removeClass(`first`);
      }

      if (i === this.widgets.length - 1) {
        widget.container.addClass(`last`);
      } else {
        widget.container.removeClass(`last`);
      }

    }, this);
  };

  Body.prototype.remove_item = function() {
    var item = arguments[0];
    if (arguments.length === 2) { item = arguments[1]; }

    this.widgets = _.without(this.widgets, item);
    item.container.remove();

    this.update_items();
  };

  Body.prototype.enable = function() {
    this.disabled = false;
  };

  Body.prototype.disable = function() {
    this.disabled = true;
  };

  Body.prototype.activate = function(fire_event, label) {
    if (this.disabled) { return; }

    this.active = true;
    if (fire_event) { this.container.trigger(`body-activated`); }

    // we fire this on activate since the intitial label_changed
    // call might be fired when the dropdown has already been hidden
    // and thus any position calculations would have failed
    this.label_changed(null, label);

    this.show();
    return this;
  };

  Body.prototype.show = function() {
    this.container.show();
    mp.utility.bind_esc(this.id, function(ev) {
      this.deactivate(false);
    }, this);
  };

  Body.prototype.deactivate = function(skip_event, label) {
    if (!this.disabled && this.active) {
      this.active = false;
      if (!skip_event) {
        this.container.trigger(`body-deactivated`);
      }
      this.hide();
      return this;
    }
  };

  Body.prototype.hide = function() {
    this.container.hide();
    mp.utility.unbind_esc(this.id);
  };

  Body.prototype.toggle_active = function(change) {
    if (this.active) {
      this.deactivate(change);
    } else {
      this.activate(change);
    }
  };

  Body.prototype.selected = function() {
    return _.detect(this.widgets, function(widget) {
      return widget.selected;
    });
  };

  // except: optional, pass a widget here to not deselect it
  Body.prototype.deselect_all = function(except) {
    _.each(this.widgets, function(widget) {
      if (widget !== except && widget.selected) {
        widget.deselect();
      }
    });
  };

  Body.prototype.select_item = function(item, skip_event) {
    this.deselect_all(item);
    item.select(false);

    if (!skip_event) {
      this.container.trigger(`item-selected`, [item, this.prev_item]);
      this.prev_item = item;
    }
  };

  Body.prototype.select_first = function(skip_event) {
    if (this.widgets.length) {
      this.select_item(this.widgets[0], skip_event);
    }
  };

  Body.prototype.select_last = function(skip_event) {
    if (this.widgets.length) {
      this.select_item(this.widgets[this.widgets.length - 1]);
    }
  };

  Body.prototype.select_next = function(skip_event) {
    var selected = this.selected();
    if (_.isArray(selected)) { return; }

    var index = _.indexOf(this.widgets, selected);
    if (index < this.widgets.length - 1) {
      var next = this.widgets[index + 1];
      this.select_item(next, skip_event);
    }
  };

  Body.prototype.select_previous = function(skip_event) {
    var selected = this.selected();
    if (!selected) { selected = this.widgets[this.widgets.length - 1]; }
    else if (_.isArray(selected)) { return; }

    var index = _.indexOf(this.widgets, selected);
    if (index > 0) {
      var prev = this.widgets[index - 1];
      this.select_item(prev, skip_event);
    }
  };

  Body.prototype.get_item_by_val = function(val) {
    return _.detect(this.widgets, function(widget) {
      if (_.isEqual(widget.val(), val)) {
        return true;
      }
    });
  };

  Body.prototype.get_item_by_id = function(id) {
    return _.detect(this.widgets, function(widget) {
      if (widget.val().id === id) {
        return true;
      }
    });

  };

  /* Item is a jswidget representing a single item in the dropdown body */

  function Item() {
    this.selected = false;
  }
  _.inherit(Item, JSWidget);

  Item.prototype.create = function(div, config) {
    Item.superclass.create.call(this, div);
    this.enabled = true;
    this.bindings();
    this.config = _.extend(this.default_config(), config);
    this.container.addClass(`dropdown_item_widget`);
    return this;
  };

  // eslint-disable-next-line sonarjs/no-identical-functions
  Item.prototype.default_config = function() {
    return {
      // default_config
    };
  };

  Item.prototype.bindings = function() {
    this.click_handler = this.click_handler || _.bind(this.select, this);
    this.container.off(`click`, this.click_handler);
    this.container.click(this.click_handler);

    this.mouseenter_handler = this.mouseenter_handler || _.bind(this.highlight, this);
    this.container.off(`mouseenter`, this.mouseenter_handler);
    this.container.mouseenter(this.mouseenter_handler);
  };

  Item.prototype.update = function(item) {
    // for different value and display, [val, display], else just a string for both
    this._set_value(item);
    this._set_content(item);
    return this;
  };

  Item.prototype._set_value = function(item) {
    if (_.isArray(item)) {
      this.value = item[0];
    } else {
      this.value = item;
    }
  };

  Item.prototype._set_content = function(item) {
    if (_.isArray(item)) {
      this.display_value = item[1];
    } else {
      this.display_value = item;
    }
    if (this.config.raw_html_item_labels) {
      this.container.html(this.display_value);
    } else {
      this.container.text(this.display_value);
    }
  };

  Item.prototype.title = function() {
    return this.display_value;
  };

  Item.prototype.enable = function() {
    var success = !this.enabled;
    this.enabled = true;
    this.container.removeClass(`disabled`);
    return success;
  };
  Item.prototype.disable = function() {
    var success = this.enabled;
    this.enabled = false;
    this.container.addClass(`disabled`);
    return success;
  };

  Item.prototype.select = function(change) {
    if (!this.enabled) {
      if (change) {
        this.container.trigger(`disabled-dropdown-item-selected`, this);
      }
      return;
    }
    // we only fire item-selected if we are just getting selected
    // now, unless we are a menu, then we fire change
    if (change && (!this.selected || this.config.menu)) {
      this.container.trigger(`dropdown-item-selected`, this);
    }
    this.selected = true;
    this.container.addClass(`selected`);
  };

  Item.prototype.highlight = function() {
    this.container.trigger(`dropdown-item-highlight`, this);
  };

  Item.prototype.deselect = function() {
    var success = this.selected;
    this.selected = false;
    this.container.removeClass(`selected`);
    return success;
  };

  // this function should be called in a subclass, and will remove the
  // item from the entire stack
  Item.prototype.remove = function() {
    this.deselect();
    this.container.trigger(`item-removed`, this);
  };

  Dropdown.Label = Label;
  Dropdown.Body = Body;
  Dropdown.Item = Item;

  return {
    Dropdown,
  };
});

}.call(window));